import axios from '../axios';
import { useQuery } from 'react-query';

export function useSingleMatric() {
  return useQuery('singleMatric', () =>
    axios.get('/singleMatric').then((res) => res.data),
  );
}

export function useAllHostSessions(request) {
  let queryString = '?';
  queryString += `chargers=${
    request?.chargers?.length > 0 ? request?.chargers?.join(',') : ''
  }`;

  queryString += `&state=${
    request?.states?.length > 0 ? request.states?.join(',') : ''
  }`;

  if (request?.startDate) {
    queryString += `&startDate=${request.startDate}`;
  }
  if (request?.endDate) {
    queryString += `&endDate=${request.endDate}`;
  }

  return useQuery(
    [
      'allHostSessions',
      request?.chargers?.length,
      request?.states?.length,
      request?.startDate,
      request?.endDate,
    ],
    () =>
      // axios.get(`/users/allHostSessions${queryString}`).then((res) => res.data),
      axios
        .get(`/host/analytics/getMultiChargerMultiMonthSessions${queryString}`)
        .then((res) => res.data),
    {
      enabled: !!request,
    },
  );
}

/**
 *
 * @param {*} groupBy
 * 0 = yearly
 * 1 = monthly
 * 2 = daily
 * @returns
 */
// export function useTimeGroupAnalytics(groupBy) {
//   const axios = useAxios();
//   return useQuery(['generalTimeGroupAnalytics', groupBy], () =>
//     axios
//       .get(`/generalTimeGroupAnalytics?byGrouping=${groupBy}`)
//       .then(res => res.data),
//   );
// }

// export function useStateTimeGroupAnalytics(groupBy = 1) {
//   const axios = useAxios();
//   return useQuery(['generalStateTimeGrouppedAnalytics', groupBy], () =>
//     axios
//       .get(`/generalStateTimeGrouppedAnalytics?byGrouping=${groupBy}`)
//       .then(res => res.data),
//   );
// }

/**
 *
 */
// export function useChargersAnalytics(request) {
//   let queryString = '?';
//   forOwn(request, (value, key) => {
//     if (key === 'chargerIds') {
//       if (request[key] && request[key].length > 0)
//         queryString += `chargerIds=[${request[key].join(',')}]`;
//     } else {
//       queryString += `${key}=${request[key]}&`;
//     }
//   });

// const axios = useAxios();
// return useQuery(
//   ['chargersAnalytics', request.offset],
//   () =>
//     axios.get(`/chargerWiseMonthlyAnalytics${queryString}`).then(res => ({
//       list: map(res?.data?.data, charger => ({
//         ...charger,
//         MONTH: toNumber(charger.DATE_CREATED.split('-')[0]),
//         YEAR: toNumber(charger.DATE_CREATED.split('-')[1]),
//       })),
//       totalChargerRecordsCount: res?.data?.TotalChargerRecordsCount || 0,
//     })),
//   {
//     enabled: !!request.year,
//   },
// );
// }
